import * as React from 'react'
import { Link } from 'react-router-dom'

import { Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'

import AppIcon from 'modules/app_store/components/AppIcon'
import configurator from 'modules/app_store/lib/SubscriptionAddonConfigurator'
import { getApplicationLabels } from 'modules/app_store/lib/getApplicationLabels'
import { APPS } from 'modules/billing/lib/types'
import { companySubscription } from 'modules/billing/store/collections/subscriptions'
import { FAMILIES } from 'modules/billing/store/models/Plan'
import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

import styles from './index.module.scss'

interface InstalledTagProps {
  installed: boolean
}

const InstalledTag = ({ installed }: InstalledTagProps) => {
  if (!installed) {
    return null
  }

  return (
    <div className={styles.tag}>
      <Tag type="neutral">{i18n.t('app_store_v2.common.card.installed')}</Tag>
    </div>
  )
}
interface Props {
  subscriptionAddon: SubscriptionAddon
}

const Card = ({ subscriptionAddon }: Props) => {
  const { enabled, id, type } = subscriptionAddon.attributes
  const { navigation } = useNavigation()
  configurator.getSubscriptionAddonConfig(subscriptionAddon, navigation)

  if (id === APPS.join && !hasFeature('ats_promote_join')) {
    return null
  }

  if (id === APPS.payroll_bundle && !hasFeature('display_new_payroll')) {
    return null
  }

  // TODO: [document-templates] This is temporary
  const isEnterprise = companySubscription(companies.current)?.attributes.plan.includes(
    FAMILIES.enterprise
  )

  if (id === APPS.document_templates && !isEnterprise && !hasFeature('document_templates')) {
    return null
  }

  const { title, description } = getApplicationLabels(type, id)

  return (
    <Link to={navigation.appStore.id.general.fullPath({ id })}>
      <div className={styles.card} data-testid="app-card">
        <div className={styles.icon} data-testid="app-icon">
          <AppIcon id={id} size={40} isVerified={subscriptionAddon.isApp} />
        </div>
        <InstalledTag installed={enabled} />
        <Text weight="medium" size="300" color="grey1000">
          {title}
        </Text>
        <Text size="200">{description}</Text>
      </div>
    </Link>
  )
}

export default observer(Card)
